// Route metadata naming the page promo is showing, for the browser tab the One Retail shell owns
// - ADR-018 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/018-shell-owns-the-tab-title.md
// A route declares `meta.tabTitle` — an i18n key, or a (route, record) => string resolver for a
// page named after an entity. The detail is the page alone; the shell adds the product name and
// the platform suffix. Standalone promo has no tab title to write, so nothing here runs outside the shell.

import { watch } from 'vue';
import i18n from '@/js/vue-i18n';
import { toSentenceCase } from '@/js/utils/string-utils';

export const TAB_TITLE_META_KEY = 'tabTitle';

// Deepest-first: the most specific record names the page, and an unresolved entity falls back to the
// section it sits in rather than to nothing. `record.meta`, not `route.meta`, to match the recents
// walk — the section that names the page is an ancestor of the route the user is on.
export function getTabTitleDetailFromRoute(route) {
    const matched = route?.matched ?? [];
    for (let i = matched.length - 1; i >= 0; i -= 1) {
        const record = matched[i];
        const value = record.meta?.[TAB_TITLE_META_KEY];
        if (value) {
            // Section keys are navbar copy, which is lower-cased in the catalogues; the navbar
            // sentence-cases them the same way.
            const detail =
                typeof value === 'function'
                    ? value(route, record)
                    : toSentenceCase(i18n.global.t(value));
            const trimmed = String(detail ?? '').trim();
            if (trimmed) return trimmed;
        }
    }
    return null;
}

// Resolving inside the getter makes the store reads dependencies, so the detail re-reports once the
// entity loads. A primitive return, so an unchanged detail reports once.
export function watchAndReportTabTitle(currentRoute, report) {
    return watch(() => getTabTitleDetailFromRoute(currentRoute()), report, { immediate: true });
}
